// extracted by mini-css-extract-plugin
export default {"img-preview":"qEYaB","img-preview_upload":"G9Ahr","img-preview__img":"kOlVD","img-preview__img_orientation_horizontal":"czaI4","img-preview__img_orientation_vertical":"dNJaF"};